import React from "react";
import styled from "styled-components";
import { Text, COLOR_SYSTEM, Icon } from "components/atoms";

const FAQS: { q: string; a: string }[] = [
  {
    q: "멤버십은 어떤 혜택이 있나요?",
    a: "월 정액으로 AI 처방 분석을 횟수 제한 없이 이용하실 수 있습니다. 포인트 차감 없이 모든 분석이 즉시 가능합니다.",
  },
  {
    q: "월 요금제와 연 요금제의 차이는 무엇인가요?",
    a: "월 요금제는 30,000원/월, 연 요금제는 300,000원/년입니다. 연 요금제는 2개월 무료 혜택으로 약 16.7% 저렴합니다.",
  },
  {
    q: "자동결제는 언제 이뤄지나요?",
    a: "가입일을 기준으로 매월(또는 매년) 동일한 날짜에 등록하신 카드로 자동 결제됩니다.",
  },
  {
    q: "해지하면 바로 권한이 사라지나요?",
    a: "아닙니다. 현재 결제 주기 만료일까지는 그대로 이용하실 수 있으며, 만료 전이라면 '다시 구독' 버튼으로 해지를 취소할 수도 있습니다.",
  },
  {
    q: "결제 카드를 변경하고 싶어요.",
    a: "'현황' 탭의 멤버십 카드에서 '카드 변경' 버튼을 누르시면 됩니다. 추가 금액은 청구되지 않으며 다음 결제부터 새 카드로 청구됩니다.",
  },
  {
    q: "분석 중 오류가 발생하면 포인트가 환불되나요?",
    a: "네, 시스템 오류로 인해 분석이 정상적으로 완료되지 않은 경우에는 사용된 포인트가 자동으로 환불 처리됩니다.",
  },
  {
    q: "같은 환자, 같은 내용으로 다시 분석해도 포인트가 차감되나요?",
    a: "네, 동일한 내용이더라도 새로운 분석을 요청하실 때마다 포인트가 차감됩니다. 멤버십 회원은 차감 없이 무제한 이용 가능합니다.",
  },
];

const NOTES: string[] = [
  "AI 분석은 참고용이며, 최종 판단은 약사의 전문성에 따라야 합니다",
  "분석 시작 후에는 취소 및 환불이 불가능합니다",
  "멤버십은 매월(또는 매년) 자동결제되며, 해지 전까지 지속됩니다",
  "결제 영수증은 '내역' 탭에서 확인 가능합니다",
  "부가세 포함 가격이며, 환불은 별도 정책에 따릅니다",
];

const FaqTab: React.FC = () => (
  <Container>
    <Section>
      <SectionTitle>
        <Icon name="Question Mark" size={24} color={COLOR_SYSTEM.get("Blue")[600]} />
        <Text textType="H3" color={COLOR_SYSTEM.get("Gray")[800]}>
          자주 묻는 질문
        </Text>
      </SectionTitle>
      {FAQS.map((f, i) => (
        <FaqItem key={i}>
          <Text textType="Body1Medium" color={COLOR_SYSTEM.get("Gray")[800]}>
            Q. {f.q}
          </Text>
          <Answer textType="Body2" color={COLOR_SYSTEM.get("Gray")[600]}>
            A. {f.a}
          </Answer>
        </FaqItem>
      ))}
    </Section>

    <Section>
      <SectionTitle>
        <Icon name="Exclamation Mark Circle" size={24} color={COLOR_SYSTEM.get("Orange")[600]} />
        <Text textType="H3" color={COLOR_SYSTEM.get("Gray")[800]}>
          이용 시 주의사항
        </Text>
      </SectionTitle>
      <WarningBox>
        {NOTES.map((n, i) => (
          <NoteLine key={i} textType="Body2" color={COLOR_SYSTEM.get("Gray")[700]}>
            • {n}
          </NoteLine>
        ))}
      </WarningBox>
    </Section>
  </Container>
);

export default FaqTab;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Section = styled.div``;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

const FaqItem = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid ${COLOR_SYSTEM.get("Gray")[100]};

  &:last-child {
    border-bottom: none;
  }
`;

const Answer = styled(Text)`
  display: block;
  margin-top: 8px;
`;

const WarningBox = styled.div`
  background: ${COLOR_SYSTEM.get("Orange")[10]};
  border-radius: 12px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const NoteLine = styled(Text)`
  display: block;
`;
